"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateCommonPassedProps = exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.date.to-string.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _components = require("./components");
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _validations = require("./validations");
var _propTypes = require("prop-types");
var _utils = require("./utils");
var _parse = require("./parse");
var _formElements = require("@evidation/form-elements");
var _lodash = _interopRequireDefault(require("lodash"));
var _dateFns = require("date-fns");
var _format = require("./format");
var _states = _interopRequireDefault(require("./states"));
var _basicInputs = require("./components/basicInputs");
var _compat = require("./compat");
var _excluded = ["collapseable", "i", "label", "smallLabel", "description", "question_description", "title", "labelStyle", "styles", "config", "validate", "fieldSpacing", "normalize", "format", "parse", "disabled"],
  _excluded2 = ["components", "interface", "label", "smallLabel", "description", "question_description", "title", "labelStyle", "inputStyle", "options", "config", "validations", "fieldSpacing", "normalize", "format", "parse", "collapseable", "ComponentWrapper", "nowDate", "clearAllValidations"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateCommonPassedProps = exports.generateCommonPassedProps = function generateCommonPassedProps(_ref) {
  var collapseable = _ref.collapseable,
    _ref$i = _ref.i,
    i = _ref$i === void 0 ? 0 : _ref$i,
    label = _ref.label,
    smallLabel = _ref.smallLabel,
    description = _ref.description,
    question_description = _ref.question_description,
    title = _ref.title,
    labelStyle = _ref.labelStyle,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    validate = _ref.validate,
    fieldSpacing = _ref.fieldSpacing,
    normalize = _ref.normalize,
    format = _ref.format,
    parse = _ref.parse,
    disabled = _ref.disabled,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (props.required) {
    if (validate) {
      validate = (0, _utils.composeValidators)(validate, _validations.required);
    } else {
      validate = _validations.required;
    }
  }
  var wrapperContent = {
    collapseable: collapseable,
    smallLabel: smallLabel,
    label: label,
    question_description: question_description,
    key: i,
    description: description,
    title: title,
    style: _objectSpread(_objectSpread({
      marginBottom: fieldSpacing
    }, styles), config)
  };
  var fieldName = props.name;
  var commonPassedProps = {
    name: fieldName,
    disabled: disabled
  };
  if (_lodash["default"].isFunction(normalize) && !_lodash["default"].isUndefined(normalize)) {
    commonPassedProps["normalize"] = normalize;
  }
  if (_lodash["default"].isFunction(format) && !_lodash["default"].isUndefined(format)) {
    commonPassedProps["format"] = format;
  }
  if (_lodash["default"].isFunction(parse) && !_lodash["default"].isUndefined(parse)) {
    commonPassedProps["parse"] = parse;
  }
  return {
    validate: validate,
    wrapperContent: wrapperContent,
    fieldName: fieldName,
    commonPassedProps: commonPassedProps
  };
};
var dictionaryContainsField = function dictionaryContainsField(dictionary, intf) {
  return _lodash["default"].has(dictionary, "field") && _lodash["default"].has(dictionary.field, intf);
};
var FIELDS = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FIELDS, _PureComponent);
  var _super = _createSuper(FIELDS);
  function FIELDS(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, FIELDS);
    _this = _super.call(this, props);

    // the optional validations fn in the component dictionary is a higher order fn that returns an array of validations
    // this allows us to create field level validations that use data from the form config, ie: min, max
    if (dictionaryContainsField(props.components, props["interface"]) && _lodash["default"].has(props.components.field[props["interface"]], 'validations')) {
      _this.componentDictionaryValidations = props.components.field[props["interface"]].validations(props);
    }
    return _this;
  }
  (0, _createClass2["default"])(FIELDS, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        components = _this$props.components,
        intf = _this$props["interface"],
        label = _this$props.label,
        smallLabel = _this$props.smallLabel,
        description = _this$props.description,
        question_description = _this$props.question_description,
        title = _this$props.title,
        labelStyle = _this$props.labelStyle,
        inputStyle = _this$props.inputStyle,
        opts = _this$props.options,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        validations = _this$props.validations,
        fieldSpacing = _this$props.fieldSpacing,
        normalize = _this$props.normalize,
        format = _this$props.format,
        parse = _this$props.parse,
        collapseable = _this$props.collapseable,
        _this$props$Component = _this$props.ComponentWrapper,
        ComponentWrapper = _this$props$Component === void 0 ? false : _this$props$Component,
        nowDate = _this$props.nowDate,
        _this$props$clearAllV = _this$props.clearAllValidations,
        clearAllValidations = _this$props$clearAllV === void 0 ? false : _this$props$clearAllV,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded2);
      config.disabled = this.props.disabled;
      if (!intf && !props.name && !_lodash["default"].includes(_constants.allowedNoName, intf)) {
        console.warn("Field does not have a \"name\" ".concat(intf, " ").concat(props.name, " - assigning one."));
        props["name"] = _lodash["default"].truncate(label, {
          length: 25,
          omission: ""
        });
        // return null;
      }
      var component;
      var _generateCommonPassed = generateCommonPassedProps(this.props),
        validate = _generateCommonPassed.validate,
        wrapperContent = _generateCommonPassed.wrapperContent,
        fieldName = _generateCommonPassed.fieldName,
        commonPassedProps = _generateCommonPassed.commonPassedProps;
      var options = (0, _utils.getInterfaceOptions)(this.props);

      // intercepting here for interfaces that are passed as a function
      // this will allow us to slowly migrate to a more flexible system of inputs
      var ExperimentalProps = _objectSpread({
        label: label,
        description: description,
        validate: validate,
        options: (0, _utils.generateOptionsListFromArrayOrObjectArray)(options)
      }, commonPassedProps);
      if (_lodash["default"].isFunction(intf)) {
        return /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
          component: intf
        }, ExperimentalProps));
      }

      // Old External Component Dictionary logic still used by study manager
      // see study-manager/src/components/fields/componentDictionary.js
      if (components) {
        if (_lodash["default"].has(components, "display") && _lodash["default"].has(components.display, intf)) {
          var Component = components.display[intf];
          return /*#__PURE__*/_react["default"].createElement(Component, this.props);
        } else if (_lodash["default"].has(components, "raw") && _lodash["default"].has(components.raw, intf)) {
          // RAW COMPONENT API
          // expectation is that the engineer will pass a component wrapped
          // with the react-final-form <Field /> component
          var _Component = components.raw[intf];
          return /*#__PURE__*/_react["default"].createElement(_Component, this.props);
        } else if (dictionaryContainsField(components, intf)) {
          var dictionaryComponent = _lodash["default"].has(components.field[intf], 'component') ? components.field[intf].component : components.field[intf];
          if (_lodash["default"].isArray(this.componentDictionaryValidations)) validate = _utils.composeValidators.apply(void 0, [validate].concat((0, _toConsumableArray2["default"])(this.componentDictionaryValidations)));
          return /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            component: dictionaryComponent
          }, this.props, {
            validate: validate
          }, commonPassedProps, {
            config: _objectSpread(_objectSpread({}, props), config)
          }));
        } else if (_lodash["default"].has(components, "fields") && _lodash["default"].has(components.fields, intf)) {
          return /*#__PURE__*/_react["default"].createElement(_compat.Fields, (0, _extends2["default"])({
            component: components.fields[intf]
          }, this.props));
        } else if (_lodash["default"].has(components, "fieldArray") && _lodash["default"].has(components.fieldArray, intf)) {
          return /*#__PURE__*/_react["default"].createElement(_compat.FieldArray, (0, _extends2["default"])({
            component: components.fieldArray[intf]
          }, this.props));
        }
      }

      //
      // If passed intf is not within the provided dictionary
      switch (intf) {
        case "todays_date":
          if (props.required) {
            validate = (0, _utils.composeValidators)(validate, _validations.todaysDateMustBeChecked);
          }
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label ? label : ''), /*#__PURE__*/_react["default"].createElement(_compat.Field, {
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: (0, _dateFns.format)(nowDate, 'MMMM d, yyyy'),
            name: fieldName,
            component: _components.CheckboxInput,
            ComponentWrapper: ComponentWrapper,
            validate: validate,
            parse: function parse(value) {
              return value ? (0, _dateFns.format)(nowDate, 'yyyy-MM-dd') : "";
            },
            config: _objectSpread(_objectSpread({}, props), config)
          }));
        case "buttongroup":
          props = _objectSpread(_objectSpread({}, props), {}, {
            options: options
          });
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_compat.Field, {
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            name: fieldName,
            component: _components.ButtonGroup,
            ComponentWrapper: ComponentWrapper,
            validate: validate,
            config: _objectSpread(_objectSpread({}, props), config)
          }));
        case "range_1to10":
        case "range_0to10":
        case "range_0to5":
          props = _objectSpread(_objectSpread({}, props), {}, {
            options: options
          });
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_compat.Field, {
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            name: fieldName,
            component: _components.RadioGroup,
            ComponentWrapper: ComponentWrapper,
            validate: validate,
            disabled: this.props.disabled,
            config: _objectSpread(_objectSpread(_objectSpread({}, props), config), {}, {
              disabled: this.props.disabled
            })
          }));
        case "hidden":
          return /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            component: _components.HiddenInput,
            validate: validate,
            config: _objectSpread(_objectSpread(_objectSpread({}, props), config), {}, {
              type: "hidden"
            })
          }, commonPassedProps));
        case "file":
        case "text":
        case "textinput":
        case "maskinput":
        case "numberinput":
        case "textareainput":
        case "textareaautosize":
        case "autosize":
        case "state":
        case "selectinput":
        case "heightinput":
        case "signiturepad":
        case "telinput":
        case "emailinput":
        case "passwordonly":
        case "password":
        case "date":
        case "insuranceproviderid":
        case "zip":
        case "contentacceptance":
        case "time":
        case "year":
        case "validatedtext":
          component = _components.TextInput;
          if (intf === "file") {
            component = _components.File;
            props = _lodash["default"].merge({}, props, {
              config: {
                maxFiles: _lodash["default"].has(config, 'maxFiles') ? config.maxFiles : _constants.defaultMaxFiles
              }
            });
            var additionalValidations = props.required ? [_validations.noEmptyFileArray, _validations.maxFilesUpload, _validations.maxFileSize] : [_validations.maxFilesUpload, _validations.maxFileSize];
            validate = _utils.composeValidators.apply(void 0, [validate].concat(additionalValidations));
          } else if (intf === "time") {
            component = _components.Time;
          } else if (intf === "contentacceptance") {
            component = _components.ContentAcceptance;
          } else if (intf === "zip") {
            component = _components.MaskInput;
            validate = (0, _utils.composeValidators)(validate, _validations.zipValidation);
            props.mask = "11111";
            commonPassedProps.parse = _parse.parseMaskedType;
          } else if (intf === "insuranceproviderid") {
            component = _components.InsuranceProviderId;
            validate = (0, _utils.composeValidators)(validate, _validations.humanaLengthValidation);
          } else if (intf === "date") {
            component = _components.DatePicker;
            validate = (0, _utils.composeValidators)(validate, _validations.dateValidation);
          } else if (intf === "passwordonly") {
            component = _components.TextInput;
            props.type = "password";
          } else if (intf === "password") {
            component = _components.Password;
            props.type = "password";
          } else if (intf === "emailinput") {
            component = _components.TextInput;
            props.placeholder = props.placeholder ? props.placeholder : "email@email.com";
            validate = (0, _utils.composeValidators)(validate, _validations.emailValidation);
            props.type = "email";
          } else if (intf === "textinput") {
            component = _components.TextInput;
            props.type = "text";
          } else if (intf === 'text') {
            if (this.props.text_only_validation) {
              validate = (0, _utils.composeValidators)(validate, _validations.validateTextOnly);
            }
          } else if (intf === "signiturepad") {
            component = _components.SigniturePad;
          } else if (intf === "maskinput") {
            component = _components.MaskInput;
            commonPassedProps.parse = _parse.parseMaskedType;
            if (props.mask === _basicInputs.MASK_TYPES.bloodPressure) {
              validate = (0, _utils.composeValidators)(validate, _validations.validateBloodPressure);
            }
          } else if (intf === "telinput") {
            component = _components.TextInput;
            props.placeholder = props.placeholder ? props.placeholder : "1 (555) 555-5555";
            commonPassedProps.format = _format.formatPhone;
            commonPassedProps.parse = _parse.parsePhone;
            validate = (0, _utils.composeValidators)(validate, _validations.phone);
          } else if (intf === "numberinput") {
            component = _components.NumberInput;
            // parsing numbers if no parse method is passed
            commonPassedProps.parse = !_lodash["default"].has(commonPassedProps, "parse") ? function (v) {
              return parseFloat(v, 10);
            } : commonPassedProps.parse;
          } else if (intf === "textareaautosize" || intf === "autosize") {
            component = _components.TextareaAutosize;
          } else if (intf === "textareainput") {
            component = _components.TextareaInput;
          } else if (intf === "state") {
            if (props.required) {
              validate = (0, _utils.composeValidators)(validate, _validations.selectNotDefaultValue);
            }
            component = _components.SelectInput;
            props = _objectSpread(_objectSpread({}, props), {}, {
              options: _states["default"]
            });
          } else if (intf === "year") {
            if (props.required) {
              validate = (0, _utils.composeValidators)(validate, _validations.selectNotDefaultValue);
            }
            component = _components.SelectInput;
            props = _objectSpread(_objectSpread({}, props), {}, {
              options: (0, _utils.generateDecendingOptionsListOfNumbers)()
            });
          } else if (intf === "selectinput") {
            if (props.required) {
              validate = (0, _utils.composeValidators)(validate, _validations.selectNotDefaultValue);
            }
            component = _components.SelectInput;
            props = _objectSpread(_objectSpread({}, props), {}, {
              options: (0, _utils.generateOptionsListFromArrayOrObjectArray)(options)
            });
          } else if (intf === "heightinput") {
            component = _components.HeightInput;
          } else if (intf === "validatedtext") {
            component = _components.TextInput;
            validate = (0, _utils.composeValidators)(validate, _validations.validateAlphanumeric, function (v) {
              return (0, _validations.validateMinMaxLength)(v, props.mask_custom_min, props.mask_custom_max);
            });
          }
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            component: component,
            validate: clearAllValidations ? [] : validate
          }, commonPassedProps, {
            config: _objectSpread(_objectSpread({}, props), config)
          })));
        case "connected_file":
          return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            component: _components.ConnectedFile,
            validate: validate
          }, commonPassedProps, {
            config: _objectSpread(_objectSpread({}, props), config)
          })));
        case "signature":
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            inputStyle: inputStyle,
            labelStyle: labelStyle,
            label: label,
            component: _components.Signature,
            validate: validate
          }, commonPassedProps, {
            config: _objectSpread(_objectSpread({}, props), config)
          }))), /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, null, /*#__PURE__*/_react["default"].createElement(_compat.Field, (0, _extends2["default"])({
            inputStyle: 'transparent',
            labelStyle: labelStyle,
            component: _components.TextInput,
            validate: validate,
            format: function format(value) {
              return value;
            }
          }, _lodash["default"].merge(commonPassedProps, {
            label: 'Signature Date',
            name: "".concat(props.name, "_timestamp")
          }), {
            config: _objectSpread(_objectSpread(_objectSpread({}, props), _objectSpread(_objectSpread({
              required: false
            }, config), {}, {
              disabled: true
            })), {}, {
              name: "".concat(props.name, "_timestamp")
            })
          }))));
        default:
          console.warn("Field type ".concat(intf, " \"").concat(label, "\" is not available"));
          return null;
      }
    }
  }]);
  return FIELDS;
}(_react.PureComponent);
(0, _defineProperty2["default"])(FIELDS, "displayName", 'FieldsNew');
FIELDS.defaultProps = {
  ComponentWrapper: false,
  nowDate: new Date(),
  disabled: false
};
FIELDS.propTypes = {
  ComponentWrapper: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.func, _propTypes.element]),
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  nowDate: _propTypes.object
};
var _default = exports["default"] = FIELDS;